import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { contributionTypes, fecContributionTypes } from '../../helpers/constants';
import { getLabel } from '../../helpers/labelHelper';
import { CaretDown } from '../icons';

const ContributionTypePicker = ({
  selectedKey,
  onChange,
  errorMessage,
  required,
  className,
  session,
}) => {
  const options = session.isFederal() ? fecContributionTypes : contributionTypes;
  return (
    <Dropdown
      onRenderCaretDown={() => <CaretDown />}
      className={className}
      errorMessage={errorMessage}
      label={`${getLabel('Contribution', session)} Type`}
      required={required}
      placeholder="Select"
      selectedKey={selectedKey}
      onChange={onChange}
      options={[{ key: 0, text: 'Select' }, ...options]}
    />);
};

ContributionTypePicker.propTypes = {
  selectedKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  session: PropTypes.object.isRequired,
};

ContributionTypePicker.defaultProps = {
  errorMessage: '',
  required: false,
  className: '',
};

export default ContributionTypePicker;
